import React, { useState } from 'react';
import { Card, Input, Button, message, Typography } from 'antd';
import { supabase } from './supabaseClient';

const { Title, Text } = Typography;

const Redeem = ({ user }) => {
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);

    const handleRedeem = async () => {
        if (!code.trim()) {
            message.error('Please enter a redeem code');
            return;
        }

        setLoading(true);
        try {
            const { data, error } = await supabase.functions.invoke('redeem-code', {
                body: { code: code.trim() }
            });

            if (error) throw error;

            if (data.success) {
                message.success('Code redeemed successfully!');
                setCode('');

                // Show specific success message based on the type of benefit
                if (data.type === 'subscription') {
                    message.info(`Your subscription has been extended by ${data.value.duration}`);
                } else if (data.type === 'quota') {
                    message.info(`${data.value.quota} minutes have been added to your quota`);
                }
            } else {
                message.error(data.message || 'Failed to redeem code');
            }
        } catch (error) {
            console.error('Error redeeming code:', error);
            message.error('Failed to redeem code. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ maxWidth: 600, margin: '0 auto', padding: '24px' }}>
            <Card>
                <Title level={2}>Redeem Code</Title>
                <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
                    Enter your redeem code below to claim your benefits
                </Text>

                <Input
                    size="large"
                    placeholder="Enter your redeem code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    style={{ marginBottom: 16 }}
                    onPressEnter={handleRedeem}
                />

                <Button
                    type="primary"
                    size="large"
                    block
                    loading={loading}
                    onClick={handleRedeem}
                >
                    Redeem
                </Button>
            </Card>
        </div>
    );
};

export default Redeem; 